// Libraries
import React from 'react'
import PropTypes from 'prop-types'
import { Checkbox as Checkboxantd, Tooltip } from 'antd'
import { Field, ErrorMessage } from 'formik'

const Checkbox = ({ name, label, style, tooltip, onChange, ...props }) => {
  const onChangeUpdated = (form) => {
    if (onChange) {
      return onChange
    }
    return (event) => form.setFieldValue(name, event?.target?.checked || false)
  }
  const renderCheckbox = (field, form) => {
    if (tooltip) {
      return (
        <Tooltip {...tooltip}>
          <Checkboxantd {...props} checked={field.value} onChange={onChangeUpdated(form)}>
            {label}
          </Checkboxantd>
        </Tooltip>
      )
    } else {
      return (
        <Checkboxantd {...props} checked={field.value} onChange={onChangeUpdated(form)}>
          {label}
        </Checkboxantd>
      )
    }
  }
  return (
    <div style={style}>
      <Field name={name}>{({ field, form }) => renderCheckbox(field, form)}</Field>
      <ErrorMessage name={name} component='div' className='error' />
    </div>
  )
}

Checkbox.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  onChange: PropTypes.func,
  style: PropTypes.object,
  tooltip: PropTypes.object
}

export default Checkbox
